<template>
    <div class="section-box box">
        <el-form ref="searchForm" inline label-width="90px">
            <template v-if="!(typeof(actionData.examinationsjk_add) != 'undefined'&&!actionData.examinationsjk_add)">
                <el-form-item style="margin-bottom: 30px !important;">
                    <el-button size="medium" type="primary" icon="el-icon-plus" @click="linkAddQuestions">添加试题</el-button>
                </el-form-item>
            </template>
            <template v-if="!(typeof(actionData.examinationsjk_plupdate) != 'undefined'&&!actionData.examinationsjk_plupdate)">
                <el-form-item style="margin-bottom: 30px !important;">
                    <el-button size="medium" type="primary" icon="el-icon-refresh" @click="batchShowClick(3)">批量更新</el-button>
                </el-form-item>
            </template>
            <template v-if="!(typeof(actionData.examinationsjk_pldelete) != 'undefined'&&!actionData.examinationsjk_pldelete)">
                <el-form-item style="margin-bottom: 30px !important;">
                    <el-button size="medium" type="danger" icon="el-icon-delete" @click="handleDelete(4)">批量删除</el-button>
                </el-form-item>
            </template>
            <br>
            <el-form-item label="题型：">
                <el-select size="medium" v-model="form.nquestionType" style="width:150px;" placeholder="请选择题型">
                    <el-option :value="item.value" :label="item.label" v-for="(item, index) in TEST_TYPE.TYPES" :key="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="试题分类：">
                <el-select size="medium" v-model="form.nquestionCategory" style="width:150px;" placeholder="请选择试题分类">
                    <el-option :value="item.value" :label="item.label" v-for="(item, index) in QUESTIONS_TYPE.CLASSIFY" :key="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="试题内容：">
                <el-input size="medium" style="width:150px;" v-model="form.squestions" placeholder="请输入试题内容" type="text" />
            </el-form-item>
            <el-form-item label="试题难度：">
                <el-select size="medium" v-model="form.nquestionLevel" style="width:150px;" placeholder="请选择试题难度">
                    <el-option :value="item.value" :label="item.label" v-for="(item, index) in TEST_TYPE.DIFFICULTY" :key="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="二级产品：">
                <el-select size="medium" v-model="form.ntwoProductId" filterable style="width:150px;" placeholder="请选择二级产品" @change="getThreeProductList">
                    <el-option :value="item.key" :label="item.value" v-for="(item, index) in secondProductList" :key="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="三级产品：">
                <el-select size="medium" v-model="form.nthreeProductId" filterable style="width:150px;" placeholder="请选择三级产品">
                    <el-option :value="item.key" :label="item.value" v-for="(item, index) in threeProductList" :key="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="品牌：">
                <el-select size="medium" v-model="form.sbrandId" filterable style="width:150px;" placeholder="请选择品牌">
                    <el-option :value="item.key" :label="item.value" v-for="(item, index) in brandList" :key="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="创始人：">
                <el-input size="medium" style="width:150px;" v-model="form.createrName" placeholder="请输入创始人" type="text" />
            </el-form-item>
            <el-form-item label="创建时间：">
                <el-date-picker
                    size="medium"
                    v-model="form.pickerTime"
                    type="daterange"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                ></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="medium" type="success" @click="handleReset">重置</el-button>
            </el-form-item>
        </el-form>
        <el-table
            :stripe="true"
            v-loading="listLoading"
            :data="tableData"
            style="width: 100%;"
            height="560"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="题型" width="120">
                <template slot-scope="scope">
                    <span v-if="scope.row.nquestionType == 1">单选</span>
                    <span v-else-if="scope.row.nquestionType == 2">多选</span>
                    <span v-else-if="scope.row.nquestionType == 3">判断</span>
                    <span v-else>--</span>
                </template>
            </el-table-column>
            <el-table-column label="试题分类" width="140">
                <template slot-scope="scope">
                    <span v-if="scope.row.nquestionCategory == 1">课程考试</span>
                    <span v-else-if="scope.row.nquestionCategory == 2">服务安全规范</span>
                    <span v-else-if="scope.row.nquestionCategory == 3">服务能力</span>
                    <span v-else>--</span>
                </template>
            </el-table-column>
            <el-table-column prop="squestions" label="试题内容" show-overflow-tooltip width="260"></el-table-column>
            <el-table-column label="试题难度" width="120">
                <template slot-scope="scope">
                    <span v-if="scope.row.nquestionLevel === 0">无</span>
                    <span v-else-if="scope.row.nquestionLevel == 1">入门</span>
                    <span v-else-if="scope.row.nquestionLevel == 2">中等</span>
                    <span v-else-if="scope.row.nquestionLevel == 3">困难</span>
                    <span v-else>--</span>
                </template>
            </el-table-column>
            <el-table-column label="二级产品" show-overflow-tooltip width="120">
                <template slot-scope="scope">
                    <span>{{ scope.row.twoProductName||'--' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="三级产品" show-overflow-tooltip width="120">
                <template slot-scope="scope">
                    <span>{{ scope.row.threeProductName||'--' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="品牌" show-overflow-tooltip width="120">
                <template slot-scope="scope">
                    <span>{{ scope.row.sbrand||'--' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="创始人" show-overflow-tooltip width="120">
                <template slot-scope="scope">
                    <span>{{ scope.row.createrName||'--' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" width="180">
                <template slot-scope="scope">
                    <span>{{ scope.row.daddDate||'--' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="180">
                <template slot-scope="scope">
                    <div class="btn-groups">
                        <template v-if="!(typeof(actionData.examinationsjk_edit) != 'undefined'&&!actionData.examinationsjk_edit)">
                            <el-button size="mini" @click.native.prevent="editorRow(scope.row)">编辑</el-button>
                        </template>
                        <template  v-if="!(typeof(actionData.examinationsjk_delete) != 'undefined'&&!actionData.examinationsjk_delete)">
                            <el-button @click.native.prevent="deleteRow(scope.row)" type="danger" size="mini">删除</el-button>
                        </template>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="form.pageNum"
                :page-sizes="[10, 20, 50, 100, 200]"
                :page-size="form.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog title="批量更新" :visible.sync="batchShow" width="30%" center :before-close="handleClose">
            <el-form>
                <el-form-item label="试题分类：">
                    <el-select size="medium" v-model="batch.nquestionCategory" style="width: 80%" placeholder="请选择试题分类">
                        <el-option :value="item.value" :label="item.label" v-for="(item, index) in QUESTIONS_TYPE.CLASSIFY" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="试题难度：">
                    <el-select size="medium" v-model="batch.nquestionLevel" style="width: 80%" placeholder="请选择试题难度">
                        <el-option :value="item.value" :label="item.label" v-for="(item, index) in TEST_TYPE.DIFFICULTY" :key="index"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="batchModiClick" :loading="batchLoading">确 定</el-button>
            </span>
        </el-dialog>
        <CusModal ref="enterings" @onSubmit="onSubmit"/>
    </div>
</template>

<script>
import { TEST_TYPE, QUESTIONS_TYPE } from '@/config/const/common.js'
import { mapState } from 'vuex'
import { getThreeProductList } from '@/service/area'
import CusModal from './index/modal'
import { getActionData } from '@/utils/store'
import {
    questionBankList,           //获取列表
    questionBankBatchModi,      //批量更新
    questionBankBatchDel,       //批量删除
    questionBankModel,          //试题 新增/修改
    questionBankIsExist,        //点击批量更新/批量删除/编辑/删除调用
} from "@/service/examination";
  export default {
    components: {
      CusModal
    },
    data() {
      return {
        actionData: JSON.parse(getActionData()),      //功能按钮每个页面必须用

        listLoading: false,
        TEST_TYPE,
        QUESTIONS_TYPE,
        threeProductList: [],
        form: {
            pageNum: 1,
            pageSize: 10,
            rational: true,
            spaperNo: '',

            nquestionType: '',          //题型
            nquestionCategory: '',      //试题分类
            nquestionLevel: '',         //难度
            ntwoProductId: '',               //二级产品id
            nthreeProductId: '',             //三级产品id
            sbrandId: '',               //品牌id
            squestions: '',             //试题内容
            createrName: '',            //创始人
            pickerTime: [],             //创建时间
        },
        searchData:{},
        oraginForm:{},
        total: 0,                       //总条数
        tableData: [],
        multipleSelection: [],          //多选

        batchShow: false,
        batch: {
            nquestionCategory: '',      //试题分类
            nquestionLevel: '',         //难度
        },
        batchData: {},
        batchForm: {},
        batchLoading: false,            //批量更新loading

        delTisp:'同时也会删除试卷中关联的试题',
        delTitle: '确定要删除选中试题吗？',

        // ifDestroy: false,                //关闭时销毁 Dialog 中的元素
        editorShow: false,               //编辑
        details: null,                   //编辑用的详情
      }
    },
    activated(){
        this.handleSearch()
    },
    created() {
        this.oraginForm = JSON.parse(JSON.stringify(this.form))
        this.batchForm = JSON.parse(JSON.stringify(this.batch))
    },
    computed: {
        ...mapState({
            secondProductList: state => state.area.secondProductList,
            brandList: state => state.area.brandList
        })
    },
    mounted() {
        // this.$refs.dialog.open()
    },
    methods: {
        // 获取三级产品
        getThreeProductList(){
            getThreeProductList({ParentId:this.form.ntwoProductId}).then(res=>{
                res.Result == 1 ? this.threeProductList=res.Data: [];
                this.form.nthreeProductId = "";
            })
        },
        handleSearch() {
            this.searchData = Object.assign({}, this.form)
            this.handleCurrentChange(1)
        },
        async GetQuestionBankList(){
            this.listLoading = true
            let data = JSON.parse(JSON.stringify(this.searchData))
            !data.nquestionType && delete data.nquestionType
            !data.nquestionCategory && delete data.nquestionCategory
            data.nquestionLevel==='' && delete data.nquestionLevel
            !data.ntwoProductId && delete data.ntwoProductId
            !data.nthreeProductId && delete data.nthreeProductId
            !data.sbrandId && delete data.sbrandId
            !data.squestions && delete data.squestions
            !data.createrName && delete data.createrName
            !data.spaperNo && delete data.spaperNo
            if (data.pickerTime && data.pickerTime.length) {
                data.daddDateBegin = data.pickerTime[0] + ' 00:00:01'
                data.daddDateEnd = data.pickerTime[1] + ' 23:59:59'
            }
            delete data.pickerTime
            let res = await questionBankList(data)
            this.listLoading = false
            
            this.tableData = res.Data.datas
            // this.tableData = this.tableData.map(obj => {
            //     this.$set(obj, 'detailsLoading', false)
            //     // obj.detailsLoading = false
            //     return obj
            // })
            this.total = res.Data.total
        },
        editorRow(rows) {
            let data = {
                nquestionNos:[],
                operateType: 1,
            }
            data.nquestionNos.push(rows.nquestionNo)
            questionBankIsExist(data).then(res=> {
                if(res.Result != 1) {
                    this.$confirm(res.Message, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$refs.enterings.open(rows)
                    }).catch(() => {});
                }else{
                    this.$refs.enterings.open(rows)
                }
            })
        },
        deleteRow(rows) {
            let data = {
                nquestionNos:[],
                operateType: 2,
            }
            data.nquestionNos.push(rows.nquestionNo)
            questionBankIsExist(data).then(res=> {
                if(res.Result != 1) {
                   return this.$alert(res.Message, '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    });
                }
                this.$confirm(this.delTisp, this.delTitle, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const loading = this.$loading({
                        lock: true,
                        text: "删除中...",
                        spinner: "el-icon-loading",
                        background: "rgba(0, 0, 0, 0.7)"
                    })
                    delete data.operateType
                    questionBankBatchDel(data).then(r=> {
                        loading.close();
                        if(r.Result != 1) {
                            return this.$message.error(r.Message)
                        }
                        this.$message.success('删除成功!');
                        this.handleSearch()
                    })
                }).catch(() => {});
            })
        },
        handleSizeChange(val) {
            if (this.listLoading) return
            this.form.pageNum = 1
            this.form.pageSize = val
            this.searchData.pageNum = 1
            this.searchData.pageSize = val
            this.GetQuestionBankList()
        },
        handleCurrentChange(val) {
            if (this.listLoading) return
            this.form.pageNum = val
            this.searchData.pageNum = val
            this.GetQuestionBankList()
        },
        handleReset() {
            this.form = JSON.parse(JSON.stringify(this.oraginForm))
            this.handleSearch()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        batchShowClick(type) {
            if(this.multipleSelection.length == 0) {
                return this.$message.warning('请选择需要更新的数据')
            }
            let data = {
                nquestionNos: [],
                operateType: type
            }
            this.multipleSelection.map(obj => {
                data.nquestionNos.push(obj.nquestionNo)
            })
            questionBankIsExist(data).then(res=> {
                if(res.Result != 1) {
                   return this.$alert(res.Message, '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    });
                }
                this.batchShow = true
            })
        },
        handleClose(done){
            this.batch = JSON.parse(JSON.stringify(this.batchForm))
            done()
        },
        batchModiClick(){
            if(this.batchLoading) return;
            let pkids = []
            if(!this.batch.nquestionCategory) {
                return this.$message.warning('请选择试题分类')
            }
            if(this.batch.nquestionLevel === '') {
                return this.$message.warning('请选择试题难度')
            }
            this.batchData = Object.assign({}, this.batch)
            this.multipleSelection.map(obj => {
                pkids.push(obj.pkid)
            })
            let data = JSON.parse(JSON.stringify(this.batchData))
            data.pkids = pkids
            this.batchLoading = true
            questionBankBatchModi(data).then(res=> {
                this.batchLoading = false
                if(res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                this.batchShow = false;
                this.batch = JSON.parse(JSON.stringify(this.batchForm))
                this.$message.success('更新成功');
                this.handleSearch()
            })
        },
        handleDelete(type){
            if(this.multipleSelection.length == 0) {
                return this.$message.warning('请选择需要删除的数据')
            }
            let data = {
                nquestionNos:[],
                operateType: type
            }
            this.multipleSelection.map(obj => {
                data.nquestionNos.push(obj.nquestionNo)
            })
            questionBankIsExist(data).then(res=> {
                if(res.Result != 1) {
                   return this.$alert(res.Message, '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    });
                }
                this.$confirm(this.delTisp, this.delTitle, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const loading = this.$loading({
                        lock: true,
                        text: "删除中...",
                        spinner: "el-icon-loading",
                        background: "rgba(0, 0, 0, 0.7)"
                    })
                    delete data.operateType
                    questionBankBatchDel(data).then(r=> {
                        loading.close();
                        if(r.Result != 1) {
                            return this.$message.error(r.Message)
                        }
                        this.$message.success('删除成功!');
                        this.handleSearch()
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });
                }).catch(() => {});
            })
            
        },
        linkAddQuestions(){
            this.$router.push('/examination/addQuestions')
        },
        onSubmit(val){
            questionBankModel(val).then(res=> {
                if(res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                this.$message.success('修改成功！')
                this.$refs.enterings.editorClose()
                this.handleSearch()
            })
        },
    }
  }
</script>

<style lang="scss">
.box {
    .el-row {
        margin-bottom: 20px;
        &:last-child {
        margin-bottom: 0;
        }
    }
    .el-col {
        border-radius: 4px;
        text-align: right;
    }
    .row-bg {
        padding: 10px 14px;
        background-color: #f9fafc;
    }
}
</style>